import { FC, useState } from 'react'
import { Ticket } from '../../../../redux/slices/ticket/ticketModel'
import * as yup from 'yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useCreateReplyTicketMutation } from '../../../../redux/slices/ticket/apiTicketSlice'
import Swal from 'sweetalert2'
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { useAppSelector } from '../../../../redux/hook'
import { useGetAllDevicesQuery } from '../../../../redux/slices/device/apiDeviceSlice'
import { KTSVG } from '../../../../../_metronic/helpers'

type Props = {
    className?: string,
}

const schema = yup.object().shape({
    description: yup.string().trim()
        .min(5, 'Minimum 5 symbols')
        .max(1000, 'Maximum 1000 symbols')
        .required('Description is required'),
})

const DrawerReplyTicket: FC<Props> = ({ className }) => {
    const actionTicket = useAppSelector(state => state.ticket.actionTicket)
    const { data: allDevices } = useGetAllDevicesQuery(5)
    const [deviceId, setDeviceId] = useState("")
    const [relatedDevice, setRelatedDevice] = useState(false)
    const [loading, setLoading] = useState(false)
    const {
        register,
        reset,
        handleSubmit,
        formState: {
            errors,
            isSubmitting,
            isValid,

        }
    } = useForm<any>({
        resolver: yupResolver(schema),

    })
    const [createReplyTicket] = useCreateReplyTicketMutation();
    const formSubmitHandler: SubmitHandler<Ticket> = async (data: Ticket) => {
        try {
            setLoading(true);
            if (actionTicket.id && actionTicket.id !== "") {
                data.id = actionTicket.id
            }

            const result: any = await createReplyTicket(data)
            if (result.data.code == 201 || result.data.code == 200) {
                Swal.fire(
                    'Complete',
                    'Ticket has been submitted.',
                    'success'
                )
                reset()
            } else {
                Swal.fire(
                    'Error',
                    result.data.msg,
                    'error'
                )
            }
            setLoading(false)
        } catch (error) {
            Swal.fire(
                'Error ',
                'There is something wrong during the process!',
                'error'
            )
        }
    }

    return (
        <>
            <div
                id="kt_drawer_reply_ticket"
                data-kt-drawer-toggle={`#kt_drawer_reply_ticket_button`}
                data-kt-drawer-close={`#kt_drawer_reply_ticket_close`}
                tabIndex={-2}
                className={`offcanvas offcanvas-end bg-white ${className}`}
            >
                <div className="offcanvas-header bg-light-primary">
                    {actionTicket.id !== "" 
                        ?   <h5 className="offcanvas-title text-primary" id="staticBackdropLabel">
                                <KTSVG path='/media/icons/duotune/communication/com007.svg' className='svg-icon-2x text-primary me-2' />
                                Reply to Ticket: <strong>{actionTicket.reference}</strong>
                            </h5>
                        :   <h5 className="offcanvas-title text-primary" id="staticBackdropLabel">
                                <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2x text-primary me-2' />                                
                                Create a Ticket
                            </h5>
                    }
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
                </div>
                <div className="offcanvas-body text-start">
                    <div className="row">

                        {/* <FormProvider {...methods} > */}
                        <form id="frm-ticket" className='form'
                            onSubmit={handleSubmit(formSubmitHandler)}
                        >
                            {actionTicket.id === "" &&
                                <>
                                    <div className="mb-4">
                                        <div className=''>
                                            <div className='d-flex flex-stack'>
                                                <div className='d-flex'>

                                                    <div className='d-flex flex-column'>
                                                        <span className='fs-5 text-dark fw-bolder'>
                                                            Device issue
                                                        </span>
                                                        <div className='fs-6 fw-bold text-gray-400'>Enable if the ticket relates to a device.</div>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-end'>
                                                    <div className='form-check form-check-solid form-switch'>
                                                        <input
                                                            className='form-check-input w-45px h-30px'
                                                            type='checkbox'
                                                            id='chk_tfa'
                                                            checked={relatedDevice}
                                                            onChange={() =>
                                                                setRelatedDevice(!relatedDevice)
                                                            }
                                                        />
                                                        <label className='form-check-label' htmlFor='chk_tfa'></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='separator separator-dashed my-5'></div>
                                    {relatedDevice &&
                                        <div className='mb-4'>
                                            <FormControl fullWidth>
                                                <InputLabel id="select-device-label">Device</InputLabel>
                                                <Select
                                                    {...register("deviceId")}
                                                    labelId="select-device-label"
                                                    label="Device"
                                                    value={deviceId}
                                                    onChange={(e) => { setDeviceId(e.target.value) }}
                                                    MenuProps={{ disablePortal: true }}
                                                >
                                                    <MenuItem key="" value="" disabled>
                                                        Select device
                                                    </MenuItem>
                                                    {allDevices && allDevices
                                                        .slice().sort((a, b) => a.deviceName.toLowerCase() > b.deviceName.toLowerCase() ? 1 : -1)
                                                        .map((device) => {
                                                            return (
                                                                <MenuItem key={device.id} value={device.id} className='w-100'>{device.deviceName}</MenuItem>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </div>
                                    }
                                </>


                            }
                            <div className="mb-4">
                                <input type="hidden" {...register("id")} />
                                <TextField
                                    {...register("description")}
                                    label="Description"
                                    // required
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    InputLabelProps={{ shrink: true }}
                                    placeholder="Please describe the issue or your interest."
                                    multiline
                                    rows={13}

                                    error={!!errors.description}
                                />

                            </div>


                            <div className="pt-8 text-end">
                                <button type="submit" className="btn btn-primary"
                                    data-bs-dismiss="offcanvas"
                                    data-kt-drawer-dismiss="true"
                                    disabled={isSubmitting || !isValid}
                                >
                                    {loading
                                        ?
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            Please wait...{' '}
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                        :
                                        <span><i className="fa fa-paper-plane me-1 mt-n1"></i>Submit</span>
                                    }
                                </button>
                            </div>

                        </form>
                        {/* </FormProvider> */}

                    </div>
                </div>
            </div>

        </>
    )
}

export { DrawerReplyTicket }